// =============================================================================
// staffFields.js — institution and rotation, read the same way everywhere
// =============================================================================
// A person's INSTITUTION is `institution`, one of the cluster's four, below
// (ED and IP once kept it in primary_team; the backend moved it on load). A
// person's TEAM is not on the person at all: see services/teams.js.
// Mirrors src/logic/sites.py.
// =============================================================================

export const INSTITUTIONS = ['NUH', 'NTFGH', 'AH', 'JMC'];

const pick = (obj, ...keys) => {
  for (const k of keys) if (obj?.[k] !== undefined && obj?.[k] !== null && obj?.[k] !== '') return obj[k];
  return undefined;
};

/** The person's institution, or '' if none is recorded. */
export const institutionOf = (emp) => pick(emp, 'institution') || '';

/** Whether the person may only work at their own institution (main's "NTFGH ONLY"). */
export const isInstitutionOnly = (emp) => Boolean(pick(emp, 'institution_only', 'institutionOnly'));

const isoOf = (v) => (v ? String(v).slice(0, 10) : null);

export const rotationStartOf = (emp) => isoOf(pick(emp, 'active_start_date', 'activeStartDate'));
export const rotationEndOf = (emp) => isoOf(pick(emp, 'active_end_date', 'activeEndDate'));

/** Whether the person may be rostered on `dayIso` (YYYY-MM-DD). No dates = always. */
export function isOnRotation(emp, dayIso) {
  const start = rotationStartOf(emp);
  const end = rotationEndOf(emp);
  if (start && dayIso < start) return false;
  if (end && dayIso > end) return false;
  return true;
}

/** A short status for a staff card, or null when there is nothing to say. */
export function rotationBadge(emp, todayIso) {
  const start = rotationStartOf(emp);
  const end = rotationEndOf(emp);
  if (!start && !end) return null;
  if (start && todayIso < start) return { tone: 'off', label: `Starts ${start}` };
  if (end && todayIso > end) return { tone: 'off', label: `Rotation ended ${end}` };
  if (end) return { tone: 'on', label: `Until ${end}` };
  return null;
}
